import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { config } from "src/config";
import { CommentSectionModal } from "../CommentSectionForProtocol/CommentSectionModal";

const GuideSignature = (props: any) => {
    const { title, existingProtocol } = props;
    const [nameGuide, setNameGuide] = useState('');
    const [nameCoGuide1, setNameCoGuide1] = useState('');
    const [nameCoGuide2, setNameCoGuide2] = useState('');
    const [designationGuide, setDesignationGuide] = useState('');
    const [designationcoGuide1, setDesignationCoGuide1] = useState('');
    const [designationcoGuide2, setDesignationCoGuide2] = useState('');
    const [signatureGuide, setSignatureGuide] = useState('');
    const [signatureCoGuide1, setSignatureCoGuide1] = useState('');
    const [signatureCoGuide2, setSignatureCoGuide2] = useState('');
    const [showCommentSectionModal, setShowCommentSectionModal] = useState<boolean>(false);


    useEffect(() => {

        title?.data?.guide?.personal_info?.signature &&
            setSignatureGuide(
                `${config?.APP_URL}${title?.data?.guide?.personal_info?.signature}`,
            );
        title?.data?.co_guide_1?.personal_info?.signature &&
            setSignatureCoGuide1(
                `${config?.APP_URL}${title?.data?.co_guide_1?.personal_info?.signature}`,
            );

        title?.data?.co_guide_1_name && setNameCoGuide1(title.data.co_guide_1_name);
        title?.data?.guide_name && setNameGuide(title.data.guide_name);

        title?.data?.guide?.current_employment_info?.designation && setDesignationGuide(
            `${title.data.guide.current_employment_info.designation}, ${title?.data.guide?.current_employment_info?.institute_name}`
        );
        title?.data?.co_guide_1?.current_employment_info?.designation && setDesignationCoGuide1(
            `${title.data.co_guide_1.current_employment_info.designation}, ${title?.data.co_guide_1?.current_employment_info?.institute_name}`
        );

    }, [])
    return (
        <Row>
            {/* <Row>
                <Col lg={12}>
                    <Row className="justify-content-end">
                        <Col sm={1}>
                            <Button
                                type="button"
                                className="btn btn-primary btn-sm mb-3"
                                onClick={(e) => {
                                    setShowCommentSectionModal(!showCommentSectionModal);
                                }}
                            >
                                <i className="fas fa-2x fa-comments"></i>
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row> */}
            <Row >
                <Col lg={12}>
                    <div className="d-flex justify-content-around signature-header-box">
                        <div>
                            <p><b>Signature of the Guide</b></p>
                        </div>
                        <div>
                            <p><b> Signature(s) of the Co-Guide</b></p>
                        </div>
                    </div>

                </Col>
            </Row>
            <Row style={{ minHeight: '350px' }}>
                <Col lg={5} md={5}>
                    {existingProtocol?.data?.guide_approval_status === "Approve" ? (
                        <div className="guide-signature">
                            {nameGuide ? <p><b>Name:</b> {nameGuide}</p> : null}
                            {designationGuide ? <p><b>Designation:</b> {designationGuide}</p> : null}
                            {signatureGuide ?
                                <>
                                    <p><b>Signature:</b></p>

                                    <img style={{ width: '150px', marginLeft: '70px' }} src={signatureGuide} alt="signaure" />
                                </>
                                :
                                null}
                        </div>
                    ) : (
                        <div className="guide-signature">
                            {nameGuide ? <p><b>Name:</b> {nameGuide}</p> : null}
                            {designationGuide ? <p><b>Designation:</b> {designationGuide}</p> : null}                            
                            <p className={'my-4 text-center border border-dark'}><b>Signature of your Guide and Co-Guide will be generated automatically when they approve your Protocol.</b></p>
                        </div>
                    )}
                </Col>
                <Col className="vertical-line col-md-1" >
                    <div></div>
                </Col>
                <Col lg={5} md={5} className="co-guide-signature">
                    {existingProtocol?.data?.co_guide1_approval_status === "Approve" ? (
                        <div className="co-guide-signature">
                            {nameCoGuide1 ? <p><b>Name:</b> {nameCoGuide1}</p> : null}
                            {designationcoGuide1 ? <p><b>Designation:</b> {designationcoGuide1}</p> : null}
                            {signatureCoGuide1 ?
                                <>
                                    <p><b>Signature:</b></p>
                                    <img style={{ width: '150px', marginLeft: '70px' }} src={signatureCoGuide1} alt="signaure" />
                                </>
                                :
                                null}
                        </div>
                    ) : (
                        <div className="co-guide-signature">
                            {nameCoGuide1 ? <p><b>Name:</b> {nameCoGuide1}</p> : null}
                            {designationcoGuide1 ? <p><b>Designation:</b> {designationcoGuide1}</p> : null}                            
                            <p className={'my-4 text-center border border-dark'}><b>Signature of your Guide and Co-Guide will be generated automatically when they approve your Protocol.</b></p>
                        </div>
                    )}



                    {existingProtocol?.data?.co_guide2_approval_status === "Approve" ? (
                        <>
                            {nameCoGuide2 ? <hr className="horizontal-line" /> : null}
                            <div className="co-guide-signature">
                                {nameCoGuide2 ? <p><b>Name: {nameCoGuide2}</b></p> : null}
                                {designationcoGuide2 ? <p><b>Designation:</b> {designationcoGuide2}</p> : null}
                                {signatureCoGuide2 ?
                                    <>
                                        <p><b>Signature:</b></p>
                                        <img style={{ width: '150px', marginLeft: '70px' }} src={signatureCoGuide2} alt="signaure" />
                                    </>
                                :
                                null}
                            </div>
                        </>
                    ) : (
                        <>
                            {nameCoGuide2 ? <hr className="horizontal-line" /> : null}
                            <div className="co-guide-signature">
                                {nameCoGuide2 ? <p><b>Name: {nameCoGuide2}</b></p> : null}
                                {designationcoGuide2 ? <p><b>Designation:</b> {designationcoGuide2}</p> : null}                               
                            </div>
                        </>
                    )}

                    {/*                  
                    <p><b>Name: Asst. Prof. Dr. Hasanuzzaman Khan</b></p>
                    <p><b>Designation: Assistant Professor, Dhaka Medical College</b></p>
                    <p><b>Signature:</b></p>
                    <img style={{ width: '150px', marginLeft: '70px' }} src={signatureCoGuide1} alt="signaure" />

                    <hr className="horizontal-line" />
                    <p><b>Name: Asst. Prof. Dr. Hasanuzzaman Khan</b></p>
                    <p><b>Designation: Assistant Professor, Dhaka Medical College</b></p>
                    <p><b>Signature:</b></p>
                    <img style={{ width: '150px', marginLeft: '70px' }} src={signatureGuide} alt="signaure" /> */}

                </Col>
            </Row>

            {showCommentSectionModal ?
                <CommentSectionModal
                    fieldName={'signature_of_the_guide_and_co_guide'}
                    fieldLabel={'Signature of the Guide and Co-Guide'}
                    existingProtocol={existingProtocol}
                    showModal={showCommentSectionModal}
                    setShowModal={setShowCommentSectionModal}
                />
                :
                null
            }
        </Row>
    );
};

export default GuideSignature;